import { useEffect, useState } from 'react';
import { formatMetric } from '../panelConfig';

const pct = (v) =>
  v == null ? '—' : `${v >= 0 ? '+' : '−'}${Math.abs(v * 100).toLocaleString('es-UY', { maximumFractionDigits: 0 })}%`;

function Spark({ values, tone }) {
  if (!values.length) return null;
  const max = Math.max(1, ...values);
  return (
    <span className={`cat-spark ${tone}`}>
      {values.map((v, i) => (
        // eslint-disable-next-line react/no-array-index-key
        <i key={i} style={{ height: `${Math.max(1, (v / max) * 26)}px` }} />
      ))}
    </span>
  );
}

/**
 * Impacto de cambios de precio: productos que vendían y les cambió el precio,
 * con el efecto en ventas (con signo) en ambas direcciones — caídas (subió
 * precio → cayó venta) y ganadores (bajó precio → subió venta). Click en una
 * fila abre el detalle de ese producto (`onPick`). Se alimenta de ?changes=1.
 */
export default function PriceChangeImpact({ fetcher, onPick }) {
  const [items, setItems] = useState(null);

  useEffect(() => {
    let alive = true;
    (async () => {
      try {
        const res = await fetcher({ changes: true });
        if (alive) setItems(res?.items ?? []);
      } catch (_e) {
        if (alive) setItems([]);
      }
    })();
    return () => {
      alive = false;
    };
  }, [fetcher]);

  if (items == null) return <div className="cat-empty sm">Cargando impacto de precios…</div>;
  if (items.length === 0) {
    return <div className="cat-empty sm">Sin cambios de precio con impacto medible en productos que vendían.</div>;
  }

  return (
    <div className="cat-tablewrap">
      <table className="cat-table">
        <thead>
          <tr>
            <th>Producto</th>
            <th>Precio</th>
            <th>Δ precio</th>
            <th>Δ ventas</th>
            <th>Tendencia</th>
          </tr>
        </thead>
        <tbody>
          {items.map((it) => {
            const fall = it.direction === 'up' && it.sales_change_pct < 0;
            const win = it.direction === 'down' && it.sales_change_pct > 0;
            const tone = fall ? 'fall' : win ? 'win' : '';
            const salesCls =
              it.sales_change_pct > 0 ? 'cat-up' : it.sales_change_pct < 0 ? 'cat-down' : 'cat-muted';
            return (
              <tr key={it.sku} className="click" onClick={() => onPick(it.sku, it.product_name)}>
                <td>
                  {it.product_name || it.sku}
                  <span className="sku">{it.sku}</span>
                  {fall && <span className="cat-tag fall" style={{ marginLeft: 8 }}>cayó</span>}
                  {win && <span className="cat-tag win" style={{ marginLeft: 8 }}>ganó</span>}
                </td>
                <td>{formatMetric(it.price_before, 'currency')} → {formatMetric(it.price_after, 'currency')}</td>
                <td className="cat-muted">{it.direction === 'up' ? '▲' : '▼'} {pct(it.price_change_pct)}</td>
                <td className={salesCls}>{pct(it.sales_change_pct)}</td>
                <td><Spark values={it.spark || []} tone={tone} /></td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}
